<template>
  <svg
    width="288"
    height="325"
    viewBox="0 0 288 325"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M250.32 0H37.58C16.8251 0 0 16.8251 0 37.58V250.42C0 271.175 16.8251 288 37.58 288H250.32C271.075 288 287.9 271.175 287.9 250.42V37.58C287.9 16.8251 271.075 0 250.32 0Z"
      fill="#0D162C"
    />
    <path
      d="M157.68 107.13C151.33 134.5 151.33 162.51 157.68 189.88C159.92 199.39 163.94 207 175.24 207C187.6 207 191.64 199.38 193.88 189.88C200.23 162.51 200.23 134.5 193.88 107.13C191.65 97.62 187.61 90.01 175.78 90.01C163.95 90.01 159.92 97.62 157.68 107.13Z"
      fill="#6AC5A8"
    />
    <path
      d="M93.7999 107.13C87.4599 134.5 87.4599 162.51 93.7999 189.88C96.0399 199.39 100.06 207 111.36 207C123.71 207 127.76 199.38 130.01 189.88C136.35 162.51 136.35 134.5 130.01 107.13C127.76 97.62 123.74 90.01 111.91 90.01C100.07 90.01 96.0599 97.62 93.8099 107.13H93.7999Z"
      fill="#6AC5A8"
    />
    <path
      d="M90.5201 44.79C77.7601 48.43 66.4001 53.46 56.0001 59.43C51.5601 62.04 49.4001 68.05 50.6601 72.37C51.9401 76.7 56.5501 78.08 61.4901 75.98C72.8801 70.99 85.3301 67.03 99.2901 64.57C105.33 63.54 108.65 58.66 105.91 52.89C103.18 47.13 95.9501 43.17 90.5201 44.8V44.79Z"
      fill="#6AC5A8"
    />
    <path
      d="M197.39 44.83C210.13 48.45 221.47 53.46 231.84 59.41C236.27 62.01 238.42 68.01 237.16 72.32C235.88 76.65 231.27 78.03 226.34 75.94C214.97 70.97 202.55 67.03 188.61 64.59C182.58 63.57 179.27 58.7 182.01 52.94C184.74 47.18 191.97 43.22 197.39 44.84V44.83Z"
      fill="#6AC5A8"
    />
    <path
      d="M134.03 305.47C140.61 306.47 147.19 306.47 153.77 305.47C155.77 305.05 161.72 297.1 161.95 288.55C161.95 288.39 161.95 288.23 161.95 288.07C161.71 279.51 155.76 271.56 153.77 271.15C147.18 270.15 140.61 270.15 134.03 271.15C132.04 271.56 126.09 279.5 125.85 288.07C125.85 288.23 125.85 288.39 125.85 288.55C126.09 297.11 132.04 305.05 134.03 305.47Z"
      fill="#7792F4"
    />
    <path
      d="M116.88 288C117.05 282.53 114.09 276.96 107.99 274.62L54.8599 253.25C51.4599 251.95 47.6099 251.45 44.2199 252.8C35.8899 256.1 35.9099 262.08 35.9099 270.06V288.01H35.9199V305.96C35.9199 313.94 35.9099 319.92 44.2299 323.22C47.6199 324.56 51.4699 324.07 54.8699 322.77L108 301.4C114.1 299.06 117.06 293.5 116.89 288.02H116.88V288Z"
      fill="#7792F4"
    />
    <path
      d="M170.92 288C170.75 282.53 173.71 276.96 179.81 274.62L232.94 253.25C236.34 251.95 240.19 251.45 243.58 252.8C251.91 256.1 251.89 262.08 251.89 270.06V288.01H251.88V305.96C251.88 313.94 251.89 319.92 243.57 323.22C240.18 324.56 236.33 324.07 232.93 322.77L179.8 301.4C173.7 299.06 170.74 293.5 170.91 288.02H170.92V288Z"
      fill="#7792F4"
    />
  </svg>
</template>
